<template>
  <aside
      class="chat-moderation"
      :class="{active: showModeration}"
  >
    <header @click="showModeration = !showModeration"
        class="clickable smallprint"
    >
      <span>Moderation</span>
      <ChevronContract v-if="showModeration" />
      <ChevronExpand v-else />
    </header>

    <section v-if="showModeration">
      <div class="moderation-subsection">
        <h6>Delete this message</h6>

        <ButtonWithInlineConfirmation @click="$emit('delete', message.id)" :isSmall="true">
          <template #button>Delete this message...</template>
          <template #confirm>Yes - Delete</template>
        </ButtonWithInlineConfirmation>
      </div>

      <div v-if="isBanned" class="moderation-subsection">
        <h6>Attendee banned</h6>
      </div>

      <div v-else-if="canBan && !message.is_staff" class="moderation-subsection">
        <h6>Ban this attendee</h6>
        <p class="smallprint">Remove this attendee from the session and block them from returning.</p>

        <ButtonWithInlineConfirmation @click="$emit('ban', message.sender_id)" :isSmall="true">
          <template #button>Ban attendee...</template>
          <template #confirm>Yes - Ban</template>
        </ButtonWithInlineConfirmation>
      </div>

      <a :href="'/admin/attendee/' + message.sender_id"
        target="_blank"
        class="moderation-subsection smallprint">
        View attendee<BoxArrowUpRight class="icon-trailing" />
      </a>
    </section>
  </aside>
</template>

<script>
  import BoxArrowUpRight from "@/components/icons/BoxArrowUpRight";
  import ChevronContract from "@/components/icons/ChevronContract";
  import ChevronExpand from "@/components/icons/ChevronExpand";
  import ButtonWithInlineConfirmation from "@/components/shared/ButtonWithInlineConfirmation";

  export default {
    name: "ChatModeration",
    components: {
      BoxArrowUpRight,
      ButtonWithInlineConfirmation,
      ChevronContract,
      ChevronExpand,
    },
    props: {
      message: Object,
      canBan: Boolean,
      isBanned: Boolean,
    },
    data: function() {
      return {
        showModeration: false,
      }
    },
  }
</script>

<style>
.chat-moderation {
  border-radius: 5px 5px 0 0;
  background-color: #000;
  color: #fff;
  margin: 0;
  text-align: left;
}
.chat-moderation header {
  display: flex;
  font-weight: bold;
  justify-content: space-between;
  padding: 8px;
}
.chat-moderation header svg {
  height: 12px;
  width: 12px;
}
.chat-moderation section {
  padding: 0 8px 8px;
}
.chat-moderation .clickable {
  cursor: pointer;
}
.chat-moderation h6 {
  margin: 0;
}

.moderation-subsection {
  border-top: 1px solid #666;
  display: block;
  padding: 8px 0;
  margin: 0 0 10px;
}
.moderation-subsection:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
}

.chat-moderation .icon-trailing {
  margin-left: 5px;
  height: 10px;
  width: 10px;
}
</style>